"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RpcApi_apiClient;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcApi = void 0;
const Configuration_1 = require("../Configuration");
const Error_1 = require("../Error");
class RpcApi {
    constructor(apiClient) {
        _RpcApi_apiClient.set(this, void 0);
        this.create = async (data) => {
            const organizationId = await __classPrivateFieldGet(this, _RpcApi_apiClient, "f").currentOrganization();
            const response = await __classPrivateFieldGet(this, _RpcApi_apiClient, "f").post(`/v1/organizations/${organizationId}/endpoints`, { data, baseURL: Configuration_1.Configuration.rpcApiUrl });
            if (response.ok) {
                return this.createResponse(response.data);
            }
            throw new Error_1.KriptonioError({
                message: `error while creating rpc endpoint. ${response.error.stringify()}`,
            });
        };
        this.get = async (props) => {
            const response = await __classPrivateFieldGet(this, _RpcApi_apiClient, "f").get(`/v1/endpoints/${props.id}`, { baseURL: Configuration_1.Configuration.rpcApiUrl });
            if (response.ok) {
                return this.createResponse(response.data);
            }
            throw new Error_1.KriptonioError({
                message: `error while creating rpc endpoint. ${response.error.stringify()}`,
            });
        };
        this.getBundlerGasPrice = async (props) => {
            const response = await __classPrivateFieldGet(this, _RpcApi_apiClient, "f").get(`/v1/chains/${props.chainId}/bundler-gas-price`, { baseURL: Configuration_1.Configuration.rpcApiUrl });
            if (response.ok) {
                if (response.data.fees?.maxFeePerGas) {
                    return {
                        maxFeePerGas: BigInt(response.data.fees.maxFeePerGas),
                        maxPriorityFeePerGas: BigInt(response.data.fees.maxPriorityFeePerGas),
                    };
                }
                return null;
            }
            throw new Error_1.KriptonioError({
                message: `error while getting bundler gas price. ${response.error.stringify()}`,
            });
        };
        this.getOrCreate = async (props) => {
            const options = { wallet: props.wallet };
            const populatedOptions = Object.keys(options).reduce((acc, key) => {
                if (options[key] != null) {
                    acc.push(`${key}=${options[key]}`);
                }
                return acc;
            }, []);
            const response = await __classPrivateFieldGet(this, _RpcApi_apiClient, "f").get(`/v1/organizations/${props.organizationId}/endpoints/chains/${props.chainId}?${populatedOptions.join('&')}`, { baseURL: Configuration_1.Configuration.rpcApiUrl });
            if (response.ok) {
                return this.createResponse(response.data);
            }
            throw new Error_1.KriptonioError({
                message: `error while getting/creating rpc endpoint. ${response.error.stringify()}`,
            });
        };
        this.createResponse = (response) => {
            return {
                id: response.id,
                title: response.title,
                chainId: response.chainId,
                url: response.url,
            };
        };
        __classPrivateFieldSet(this, _RpcApi_apiClient, apiClient, "f");
    }
}
exports.RpcApi = RpcApi;
_RpcApi_apiClient = new WeakMap();
